import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import '../../ChatApp.css';
import StreamPlayer from '../../StreamPlayer';
import HostRequestTalkToaster from "../Toaster/HostRequestTalkToaster";
import { sendToMp } from '../../App';
import AcceptRequestNotification from './AcceptRequestNotification';
import DeclineRequestNotification from './DeclineRequestNotification';
import InviteDialog from './InviteDialog';
import AcceptedTalkRequestToaster from './AcceptedTalkRequestToaster';
import LeaveDialog from './LeaveDialog';
import MessageToaster from './MessageToaster';
import OverlayLoader from './OverlayLoader';
import ConnectionOverlay from './ConnectionOverlay';
import PreLoader from './PreLoader';
import ChatPanel from './ChatPanel';
import ParticipantPanel from './ParticipantPanel';

import InfoButton from './InfoButton';
import InfoContent from './InfoContent';
import ParticipantButton from './ParticipantButton';
import useMessageHandler from '../functions/messageHandlers';
import Toolbox from './Toolbox';
import { useDispatch, useSelector } from 'react-redux';
import { deleteGuest, setJwtPayload } from '../../redux/Participants/actions';
import { v4 as uuidv4 } from 'uuid';
import { ReactComponent as IconInfo } from "../../images/svg/information.svg";
import { ReactComponent as IconInfoFilled } from "../../images/svg/info-fill.svg";
import SettingsDialog from './SettingsDialog';
import ParticipantFullDialog from './ParticipantFullDialog';
import StreamingDotSupportDialog from './StreamingDotSupportDialog';

function Layout({ userId, username, updateCredentials, isRecent, setRecent, handleJWT, isIframeClosing }) {
    let { roomName } = useParams();
    roomName = roomName ? roomName : "public";

    let leaveLink = `${process.env.REACT_APP_FEEDBACK_URL}?meetingId=${roomName}`
    let homePageLink = process.env.REACT_APP_HOMEPAGE_URL;

    const navigate = useNavigate();
    const messageAreaRef = useRef(null);
    const guests = useSelector(state => state.participants.guests);
    const hosts = useSelector(state => state.participants.hosts);
    const presenters = useSelector(state => state.participants.presenters);
    const [localUsername, setLocalUsername] = useState(username || '');
    const [streamUrl, setStreamUrl] = useState('');
    const [stompClient, setStompClient] = useState(null);
    const [messageInput, setMessageInput] = useState('');
    const [messages, setMessages] = useState([]);
    const [connecting, setConnecting] = useState(false);
    const [chatPanel, setChatPanel] = useState(false);
    const [participantPanel, setParticipantPanel] = useState(false);
    const [filterValue, setFilterValue] = useState('');
    const [hostRequestTalkToasterShow, setHostRequestTalkToasterShow] = useState(false);
    const [messageToasterShow, setMessageToasterShow] = useState(false);
    const [infoContentShow, setInfoContentShow] = useState(false);
    const [showPreloader, setShowPreloader] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [buttonText, setButtonText] = useState("Join Meeting");
    const [overlay, setOverlay] = useState(true);
    const [connectionLost, setConnectionLost] = useState(false);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [newMessageCounter, setNewMessageCounter] = useState(0);
    const [newMessage, setNewMessage] = useState('');
    const [newMessageSender, setNewMessageSender] = useState('');
    const [isLeaveDialogOpen, setIsLeaveDialogOpen] = useState(false);
    const [talkRequestAccepted, setTalkRequestAccepted] = useState(false);
    const [talkRequestDeclined, setTalkRequestDeclined] = useState(false);
    const [invitedToTalkUserName, setInvitedToTalkUserName] = useState('');
    const [invitedToTalkUserId, setInvitedToTalkUserId] = useState('');
    const [inviterId, setInviterId] = useState('');
    const [inviterName, setInviterName] = useState('');
    const [inviteDialogVisible, setInviteDialogVisible] = useState(false);
    const [inviteAcceptanceDialogVisible, setInviteAcceptanceDialogVisible] = useState(false);
    const [usernameError, setUsernameError] = useState('');
    const [infoClass, setInfoClass] = useState('');
    const infoRef = useRef(null);
    const hoverTimeoutRef = useRef(null);
    const [raisedHands, setRaisedHands] = useState(new Set());
    const [joinTasksCompleted, setJoinTasksCompleted] = useState(false);
    const [screenPresenters, setScreenPresenters] = useState(new Set());
    const [isAutoSubmit, setIsAutoSubmit] = useState(false);
    const [meetingInfo, setMeetingInfo] = useState(null);
    const [isLongTitle, setIsLongTitle] = useState(false);
    const [replyingTo, setReplyingTo] = useState(null);
    const [isJwtValid, setIsJwtValid] = useState(true);
    const [searchParams] = useSearchParams();
    const jwtPayloadRef = useRef(null);
    const [isToolboxVisible, setIsToolboxVisible] = useState(true);
    const timeoutRef = useRef(null);
    const [settingsDialogOpen, setSettingsDialogOpen] = useState(false);
    const [participantLimitDialogOpen, setParticipantLimitDialogOpen] = useState(false);
    const [streamingDotSupportDialogOpen, setStreamingDotSupportDialogOpen] = useState(false);

    const colors = [
        '#F6C5BE',
        '#FFE6C7',
        '#FEF1D1',
        '#B9E4D0',
        '#C6F3DE',
        '#C9DAF8',
        '#E4D7F5',
        '#FFE6C7',
    ];

    const dispatch = useDispatch();

    const {
        handleJoinMessage,
        handleExistingUsersJoinMessage,
        handleLeaveMessage,
        handleChatMessage,
        handleFileMessage,
        handleReactionMessage,
        handleChatReaction,
        handleChatHistory,
        handleRaiseHandMessage,
        handleLowerHandMessage,
        handleRaisedHandsListMessage,
        handleStartScreenShare,
        handleStopScreenShare,
        handleScreenShareList,
        handleInformAboutNewHost,
        handleChatDisableMessage,
        handleReactionsDisableMessage,
        handleChatAndReactionConfig
    } = useMessageHandler(userId);

    useEffect(() => {
        if (stompClient) {
            stompClient.connect({}, onConnected, onError);
        }
    }, [stompClient]);

    useEffect(() => {
        let timer;
        if (talkRequestDeclined) {
            timer = setTimeout(() => {
                setTalkRequestDeclined(false);
            }, 10000);
        }
        return () => clearTimeout(timer);
    }, [talkRequestDeclined]);

    useEffect(() => {
        const savedCredentials = JSON.parse(localStorage.getItem(`room-${roomName}`));
        if (savedCredentials) {
            setLocalUsername(savedCredentials.username || '');
            if (isIframeClosing) {
                setIsAutoSubmit(true);
            }
        }
    }, [roomName]);

    useEffect(() => {
        return () => {
            if (isIframeClosing) {
            window.history.replaceState({}, '', window.location.pathname);
            }
        };
    }, [isIframeClosing]);

    useEffect(() => {
        if (isAutoSubmit && localUsername) {
            connect();
        }
    }, [isAutoSubmit, localUsername]);

    useEffect(() => {
        const fetchMeetingInfo = async () => {
            const baseUrl = process.env.REACT_APP_MEETING_INFO_URL;
            const apiUrl = `${baseUrl}${baseUrl.endsWith('/') ? '' : '/'}${roomName}`;
            try {
                const response = await axios.get(apiUrl);
                setMeetingInfo(response.data);
                // Check if the title is longer than 50 characters
                setIsLongTitle(response.data.meeting_title && response.data.meeting_title.length > 50);
            } catch (error) {
                console.error("Error fetching meeting info:", error);
            }
        };

        fetchMeetingInfo();
    }, [roomName]);

    useEffect(() => {
        const verifyJwt = async () => {
            if (!handleJWT) {
                return;
            }

            const jwtToken = searchParams.get('jwt');
            const payload = jwtDecode(jwtToken)

            // Set the username from JWT payload
            setLocalUsername(payload.context.user.name);

            jwtPayloadRef.current = payload;
            // console.log("searchParams", searchParams);
            // console.log("searchParams keys", searchParams.keys());
            // console.log("jwtToken", jwtToken);
            if (!jwtToken) {
                setIsJwtValid(false);
                return;
            }

            try {
                const response = await axios.post(
                    process.env.REACT_APP_JWT_VERIFICATION_URL,
                    jwtToken,
                    {
                        headers: {
                            'Content-Type': 'text/plain'
                        }
                    }
                );

                // Only update URL and set validity if verification was successful
                if (response.data === true) {

                    // Dispatch the payload to Redux store
                    dispatch(setJwtPayload(payload));

                    // Store the verified token if needed for future requests
                    localStorage.setItem('jwtToken', jwtToken);

                    // Remove jwt from URL without triggering a new verification
                    window.history.replaceState({}, '', `/${roomName}`);

                    setIsJwtValid(true);

                } else {
                    setIsJwtValid(false);
                }
            } catch (error) {
                console.error('JWT verification failed:', error);
                setIsJwtValid(false);
            }
        };

        // Only verify if we have handleJWT and a jwt parameter
        if (handleJWT && searchParams.get('jwt')) {
            verifyJwt();
        }
    }, [handleJWT, searchParams, roomName, dispatch]);

    const saveRoomCredentials = (username) => {
        const roomCredentials = { username };
        localStorage.setItem(`room-${roomName}`, JSON.stringify(roomCredentials));
        updateCredentials(username, roomName);
    };

    const connect = (event) => {
        if (localUsername && roomName) {
            if (localUsername.trim() === '') {
                setUsernameError('Please enter a valid username');
                return;
            }
            const storedCredentials = JSON.parse(localStorage.getItem(`room-${roomName}`));

            if (!storedCredentials) {
                saveRoomCredentials(localUsername);
            }

            setIsClicked(true)
            setButtonText("Loading...")
            const socket = new SockJS(`${process.env.REACT_APP_BIG_MEETING_BACKEND_URL}/websocket`, null, {
                transports: ['websocket', 'xhr-polling']
            });
            setStompClient(Stomp.over(socket));
        } else {
            alert("Invalid username");
        }
    };

    const handleLogin = async (event) => {
        event.preventDefault();

        if (localUsername.trim() === '') {
            setUsernameError('Please enter a valid username');
            return;
        }
        if (localUsername.length > process.env.REACT_APP_USERNAME_MAX_LENGTH) {
            setUsernameError(`Name cannot exceed ${process.env.REACT_APP_USERNAME_MAX_LENGTH} characters`);
            return;
        }

        try {
            // Check YouTube availability first
            await fetch('https://www.youtube.com/favicon.ico', { 
                method: 'HEAD',
                mode: 'no-cors'
            });
        } catch (error) {
            setStreamingDotSupportDialogOpen(true);
            return;
        }

        try {
            // If YouTube check passes, proceed with guest capacity check
            const guestCapacityResponse = await axios.get(`${process.env.REACT_APP_GET_GUEST_CAPACITY_URL}${roomName}`);
            const isMeetingFull = guestCapacityResponse.data;

            if (isMeetingFull === true) {
                setParticipantLimitDialogOpen(true);
                return;
            }



            // if (isMeetingFull === true) {
            //     const errorDialog = document.createElement('div');
            //     errorDialog.style.cssText = `
            //         position: fixed;
            //         top: 20px;
            //         left: 50%;
            //         transform: translateX(-50%);
            //         background-color: #ff0000;
            //         color: white;
            //         padding: 15px 25px;
            //         border-radius: 4px;
            //         z-index: 1000;
            //         font-size: 16px;
            //         opacity: 1;
            //         transition: opacity 0.3s ease-in-out;
            //     `;
            //     errorDialog.textContent = "Sorry! The Meeting Room is full!";
            //     document.body.appendChild(errorDialog);

            //     // Remove the error dialog after 5 seconds with fade out effect
            //     setTimeout(() => {
            //         errorDialog.style.opacity = '0';
            //         setTimeout(() => {
            //             document.body.removeChild(errorDialog);
            //         }, 300); // Wait for fade out animation to complete
            //     }, 5000);

            //     return;
            // }


            connect();
        } catch (error) {
            console.error("Error checking guest capacity:", error);
            setUsernameError('Unable to join meeting. Please try again.');
        }
    };

    const onConnected = () => {
        setConnecting(true);
        const convayUserId = jwtPayloadRef.current?.context?.user?.id || "anonymous";
        const convayParticipantLogId = (jwtPayloadRef.current?.context?.user?.participantLogId?.length > 0) ? jwtPayloadRef.current.context.user.participantLogId : "not_defined";

        stompClient.subscribe("/user/" + userId + "/topic/" + roomName, onMessageReceived);
        stompClient.subscribe("/topic/" + roomName, onMessageReceived);
        stompClient.subscribe("/topic/bigMeeting/" + roomName, onMessageReceived);
        if (isRecent) {
            stompClient.send("/app/chat.register", {}, JSON.stringify({
                sender: userId,
                name: localUsername,
                type: "JOIN",
                room: roomName,
                content: "recent",
                convayUserId: convayUserId,
                convayParticipantLogId: convayParticipantLogId
            }));
        } else {
            stompClient.send("/app/chat.register", {}, JSON.stringify({
                sender: userId,
                name: localUsername,
                type: "JOIN",
                room: roomName,
                convayUserId: convayUserId,
                convayParticipantLogId: convayParticipantLogId
            }));
        }
    };

    const onError = (error) => {
        console.error("WebSocket connection error:", error);
        setTimeout(() => {
            setMessages([])
            reconnect();
        }, 4000);
    };

    const reconnect = () => {
        const socket = new SockJS(`${process.env.REACT_APP_BIG_MEETING_BACKEND_URL}/websocket`, null, {
            transports: ['websocket', 'xhr-polling']
        });
        const newStompClient = Stomp.over(socket);
        setStompClient(newStompClient);
    };

    const sendChatReaction = (messageId, reaction) => {
        if (stompClient) {
            const reactionMessage = {
                sender: userId,
                name: localUsername,
                type: "CHAT_REACTION",
                room: roomName,
                content: JSON.stringify({
                    messageId: messageId,
                    reaction: reaction
                })
            };

            stompClient.send("/app/chat.reaction", {}, JSON.stringify(reactionMessage));
        }
    };

    const send = (event, parentMessageId) => {
        event.preventDefault();

        if (messageInput && stompClient) {
            const chatMessage = {
                messageId: `${userId}-${Date.now().toString(36)}-${uuidv4()}`,
                sender: userId,
                name: localUsername,
                content: messageInput,
                timestamp: new Date().toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true
                }),
                parentMessageId: parentMessageId,
                type: "CHAT",
                room: roomName,
            };
            stompClient.send("/app/chat.send", {}, JSON.stringify(chatMessage));
            setMessageInput('');
            setReplyingTo(null);
        }
    };




    const hostsRef = useRef([]);
    const presentersRef = useRef([]);
    const joinTasksCompletedRef = useRef(joinTasksCompleted);

    useEffect(() => {
        hostsRef.current = hosts;
    }, [hosts]);

    useEffect(() => {
        presentersRef.current = presenters;
    }, [presenters]);

    useEffect(() => {
        joinTasksCompletedRef.current = joinTasksCompleted;
    }, [joinTasksCompleted]);

    const onMessageReceived = (payload) => {
        const message = JSON.parse(payload.body);

        const messageHandlers = {
            JOIN: () => handleJoinMessage(message, setJoinTasksCompleted),
            USER_LIST: () => handleExistingUsersJoinMessage(message, setJoinTasksCompleted),
            LEAVE: () => handleLeaveMessage(message, isRecent, setRecent),
            CHAT: () => handleChatMessage(message, setNewMessage, setNewMessageSender, setMessageToasterShow, setMessages, setNewMessageCounter),
            FILE: () => handleFileMessage(message, setNewMessage, setNewMessageSender, setMessageToasterShow, setMessages, setNewMessageCounter),
            REACTION: () => handleReactionMessage(message, setNewMessage, setNewMessageSender, setMessageToasterShow, setMessages, setNewMessageCounter),
            CHAT_REACTION: () => handleChatReaction(message, setMessages),
            CHAT_HISTORY: () => handleChatHistory(message, setMessages),
            URL: () => setStreamUrl(message.content),
            WEBINAR_PARTICIPANT_LEAVE_PROVISION: () => confirmLeaveMeeting(), //confirmLeaveMeeting is originally needed to leave the meeting from guest end, however, kicking a guest requires same functionality, that is why the same function is used here
            WEBINAR_PARTICIPANT_SEND_TO_MP_PROVISION: () => {
                if (stompClient) {
                    const chatMessage = {
                        sender: userId,
                        name: localUsername,
                        content: '',
                        type: "LEAVE_WEBINAR",
                        room: roomName,
                    };
                    stompClient.disconnect(() => {
                        dispatch(deleteGuest(userId));
                        sendToMp(message.content);
                    });
                    stompClient.send("/app/chat.leave.webinar", {}, JSON.stringify(chatMessage));
                }
            },
            REQUEST_TO_TALK_DECLINED: () => setTalkRequestDeclined(true),
            REQUEST_TO_TALK_ACCEPTED: () => setTalkRequestAccepted(true),
            INVITE_BIG_MEETING_USER_TO_TALK: () => {
                setInvitedToTalkUserName(message.name);
                setInvitedToTalkUserId(message.sender);
                setInviterId(message.from);
                setInviterName(message.fromName);
                setInviteDialogVisible(true);
            },
            END_BIG_MEETING: endMeeting,
            RAISE_HAND: () => handleRaiseHandMessage(message, hostsRef, presentersRef, setRaisedHands),
            LOWER_HAND: () => handleLowerHandMessage(message, setRaisedHands),
            RAISED_HANDS_LIST: () => handleRaisedHandsListMessage(message, joinTasksCompletedRef, hostsRef, presentersRef, setRaisedHands, onMessageReceived, payload),
            START_SCREEN_SHARE: () => handleStartScreenShare(message, setScreenPresenters),
            STOP_SCREEN_SHARE: () => handleStopScreenShare(message, setScreenPresenters),
            SCREEN_SHARE_LIST: () => handleScreenShareList(message, joinTasksCompletedRef, setScreenPresenters, onMessageReceived, payload),
            INFORM_ABOUT_NEW_HOST: () => handleInformAboutNewHost(message),
            JIBRI_LEFT: () => setOverlay(true),
            TOGGLE_DISABLE_CHAT_FOR_GUESTS: () => handleChatDisableMessage(message),
            TOGGLE_DISABLE_REACTIONS_FOR_GUESTS: () => handleReactionsDisableMessage(message),
            CHAT_AND_REACTION_CONFIG: () => handleChatAndReactionConfig(message),
        };

        const handler = messageHandlers[message.type];
        if (handler) {
            handler();
        }
    };

    const getAvatarColor = (messageSender) => {
        let hash = 0;
        for (let i = 0; i < messageSender.length; i++) {
            hash = 31 * hash + messageSender.charCodeAt(i);
        }
        const index = Math.abs(hash % colors.length);
        return colors[index];
    };

    useEffect(() => {
        if (messageAreaRef.current) {
            messageAreaRef.current.scrollTop = messageAreaRef.current.scrollHeight;
        }
    }, [messages]);

    const handleFilterChange = e => {
        setFilterValue(e.target.value);
    };

    const handleHangupClick = () => {
        setIsLeaveDialogOpen(true);
    };

    const confirmLeaveMeeting = () => {
        setIsLeaveDialogOpen(false);
        // Clear localStorage for this room
        localStorage.removeItem(`room-${roomName}`);
        if (stompClient) {
            const chatMessage = {
                sender: userId,
                name: localUsername,
                content: '',
                type: "LEAVE_BIG_MEETING",
                room: roomName,
            };
            stompClient.send("/app/chat.leave.webinar", {}, JSON.stringify(chatMessage), () => {
                stompClient.disconnect(() => {
                    setIsLeaveDialogOpen(false);
                });
            });
        }
        window.location.href = leaveLink;
    };

    const handlePopState = (event) => {
        // Prevent the default behavior
        event.preventDefault();
        
        // Push current state again to maintain current URL
        window.history.pushState(null, '', window.location.href);
    };

    useEffect(() => {
        // Push initial state
        window.history.pushState(null, '', window.location.href);
        
        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    const endMeeting = () => {
        if (stompClient) {
            stompClient.disconnect(() => {
                handleEndMeeting();
            });
        } else {
            handleEndMeeting();
        }
    };

    const handleEndMeeting = () => {
        // window.history.pushState(null, '', homePageLink);
        // window.history.replaceState(null, '', homePageLink);
        window.location.href = leaveLink;
    };

    const cancelLeaveMeeting = () => {
        setIsLeaveDialogOpen(false);
    };

    const acceptRequestToTalk = () => {
        if (stompClient) {
            const chatMessage = {
                sender: invitedToTalkUserId,
                name: invitedToTalkUserName,
                from: inviterId,
                content: '',
                type: "INVITATION_TO_TALK_ACCEPTED",
                room: roomName
            };
            stompClient.send("/app/chat.invitation.to.talk.accepted", {}, JSON.stringify(chatMessage));
            setInviteDialogVisible(false);
            setInviteAcceptanceDialogVisible(true);
        }
    };

    const declineRequestToTalk = () => {
        if (stompClient) {
            const chatMessage = {
                sender: invitedToTalkUserId,
                name: invitedToTalkUserName,
                from: inviterId,
                content: '',
                type: "INVITATION_TO_TALK_DECLINED",
                room: roomName
            };
            stompClient.send("/app/chat.invitation.to.talk.declined", {}, JSON.stringify(chatMessage));
            setInviteDialogVisible(false);
        }
    };


    const handleParticipantButtonClick = () => {
        setParticipantPanel(!participantPanel);
        setChatPanel(false);
    };

    const handleLocalUserClick = () => {
        setSettingsDialogOpen(true);
    };

    const handlePlayerReady = () => {
        setOverlay(true);
        setTimeout(() => {
            setOverlay(false);
        }, 10000);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (infoRef.current && !infoRef.current.contains(event.target)) {
                setInfoContentShow(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [infoRef]);

    const handleInfoClick = (infoClass) => {
        setInfoContentShow(!infoContentShow);
        setInfoClass(infoClass);
    };

    const handleAcceptInvite = () => {
        acceptRequestToTalk(invitedToTalkUserId, invitedToTalkUserName, inviterId);
    };

    const handleDeclineInvite = () => {
        declineRequestToTalk(invitedToTalkUserId, invitedToTalkUserName, inviterId);
    };

    const handleConfirmLeave = () => {
        confirmLeaveMeeting();
        setIsLeaveDialogOpen(false);
    };

    const handleCancelLeave = () => {
        cancelLeaveMeeting();
        setIsLeaveDialogOpen(false);
    };

    const handleCloseMessageToaster = () => {
        setMessageToasterShow(false);
    };

    const handleCloseChatPanel = () => {
        setChatPanel(false);
        setNewMessageCounter(0);
        setMessageToasterShow(false);
    };

    const handleChatButtonClick = () => {
        setChatPanel(!chatPanel);
        setParticipantPanel(false);
        setNewMessageCounter(0);
        setMessageToasterShow(false);
    };

    let requestToTalkAcceptedMessage = `Your request to talk has been accepted by the host`;
    let requestToTalkDeclinedMessage = `Request Declined`;

    const InvalidMeetingNotification = () => (
        <div style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#ff4444',
            color: 'white',
            padding: '20px',
            borderRadius: '8px',
            textAlign: 'center',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 1000
        }}>
            <h2>Sorry, invalid meeting!</h2>
            <p>The meeting link you're trying to access is not valid.</p>
        </div>
    );

    useEffect(() => {
        const handleMouseMove = () => {
            // Show toolbox
            setIsToolboxVisible(true);
            
            // Clear existing timeout
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            
            // Set new timeout to hide toolbox after 3 seconds of inactivity
            timeoutRef.current = setTimeout(() => {
                setIsToolboxVisible(false);
            }, 10000);
        };

        // Add event listeners
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('click', handleMouseMove);

        // Cleanup
        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('click', handleMouseMove);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    // Add connection status event listeners
    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
            setConnectionLost(false);
            // Attempt to reconnect if connection was lost
            if (stompClient && !stompClient.connected) {
                reconnect();
            }
        };

        const handleOffline = () => {
            setIsOnline(false);
            setConnectionLost(true);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, [stompClient]);

    if (!isJwtValid && handleJWT) {
        const jwtToken = searchParams.get('jwt');
        if (jwtToken) {
            return <InvalidMeetingNotification />;
        }
    }

    // Add this function to handle username updates
    const handleUpdateUsername = (newUsername) => {
        setLocalUsername(newUsername);
        if (updateCredentials) {
            updateCredentials(newUsername);
        }
    };

    return (
        <div className="wrapper">
            {!connecting && (
                <div id="username-page">
                    <div className={`username-page-container ${isLongTitle ? 'long-title' : ''}`}>
                        <div className="meeting-info-container">

                            <div className="logo-container">
                                <img src={`${process.env.PUBLIC_URL}/images/Convay-logo.png`}/>
                            </div>
                            <div className="login-banner">
                                <img src={`${process.env.PUBLIC_URL}/images/Online-Communication.png`}/>
                            </div>
                            <h1 className="login-title">Bring everyone together</h1>
                            <p className="login-description">Empowering teams to connect, collaborate, and achieve together effortlessly—all within Convay.</p>
                        </div>
                        <form id="usernameForm" onSubmit={handleLogin}>
                            <div className="form-group">
                                <div className={'form-label'}>Name</div>
                                <input
                                    type="text"
                                    id="name"
                                    placeholder="Enter Your Name"
                                    autoComplete="off"
                                    className={`form-control ${usernameError ? 'error' : ''}`}
                                    autoFocus
                                    value={localUsername}
                                    onChange={(e) => {
                                        const newUsername = e.target.value;
                                        setLocalUsername(newUsername);
                                        if (newUsername.trim() === '' || newUsername.trim().length < process.env.REACT_APP_USERNAME_MIN_LENGTH) {
                                            setUsernameError('Please enter a valid username');
                                        } else if (newUsername.length > process.env.REACT_APP_USERNAME_MAX_LENGTH) {
                                            setUsernameError(`Name cannot exceed ${process.env.REACT_APP_USERNAME_MAX_LENGTH} characters`);
                                        } else {
                                            setUsernameError('');
                                        }
                                    }}
                                />
                                {usernameError && <span className="error-message" style={{ paddingTop: '10px', display: 'block' }}>{usernameError}</span>}
                            </div>
                            <div className="login-button-submit">
                                <button
                                    disabled={isClicked || usernameError}
                                    type="submit"
                                    className={`username-submit ${usernameError ? 'faded' : ''}`}
                                >
                                    {buttonText}
                                </button>

                                <div className="login-button-submit-info">
                                    <div 
                                    onClick={() => handleInfoClick('dialog-overlay') }><IconInfo /> <span className="login-button-submit-info-text">View Meeting Information</span></div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {connecting && !overlay && (
                <div className="top-meeting-info-container" style={participantPanel || chatPanel ? {left: 'calc(50% - 157.5px)'} : {}} onClick={() => handleInfoClick('info-content-top') }>
                    <IconInfoFilled /> <span className="login-button-submit-info-text">Meeting Info</span>
                </div>
            )}

            {localUsername && connecting && (
                <div id="chat-page">

                    <div
                        className={(overlay ? 'video-container overlay' : participantPanel || chatPanel ? 'video-container panel-open' : 'video-container')}>
                        <StreamPlayer streamUrl={streamUrl} chat={chatPanel} participant={participantPanel}
                            onPlayerReady={handlePlayerReady} />
                    </div>

                    {/**Will need to work here */}
                    {participantPanel && (
                        <ParticipantPanel
                            onClose={() => setParticipantPanel(false)}
                            filterValue={filterValue}
                            handleFilterChange={handleFilterChange}
                            localUsername={localUsername}
                            userId={userId}
                            getAvatarColor={getAvatarColor}
                            raisedHands={raisedHands}
                            screenPresenters={screenPresenters}
                            onLocalUserClick={handleLocalUserClick}
                        />
                    )}

                    {chatPanel && (
                        <ChatPanel
                            messages={messages}
                            userId={userId}
                            messageInput={messageInput}
                            setMessageInput={setMessageInput}
                            send={send}
                            sendChatReaction={sendChatReaction}
                            onClose={handleCloseChatPanel}
                            getAvatarColor={getAvatarColor}
                            replyingTo={replyingTo}
                            setReplyingTo={setReplyingTo}
                        />
                    )}

                    <Toolbox 
                        userId={userId}
                        localUsername={localUsername}
                        roomName={roomName}
                        meetingInfo={meetingInfo}
                        onHangup={handleHangupClick}
                        onParticipantClick={handleParticipantButtonClick}
                        onChatButtonClick={handleChatButtonClick}
                        newMessageCounter={newMessageCounter}
                        chatPanel={chatPanel}
                        participantPanel={participantPanel}
                        stompClient={stompClient}
                        onUpdateUsername={handleUpdateUsername}
                        overlay={overlay}
                        isVisible={isToolboxVisible}
                        getAvatarColor={getAvatarColor}
                    />

                    <SettingsDialog 
                        isOpen={settingsDialogOpen}
                        onClose={() => setSettingsDialogOpen(false)}
                        localUsername={localUsername}
                        onUpdateUsername={handleUpdateUsername}
                        getAvatarColor={getAvatarColor}
                    />

                    <PreLoader
                        show={showPreloader}
                        message={"The host has granted your request to talk. Admitting you shortly."}
                    />
                    
                    <OverlayLoader show={overlay} />


                    <ConnectionOverlay 
                        show={connectionLost} 
                        onRetry={reconnect}
                    />
                </div>

            )
            }


            {hostRequestTalkToasterShow && (
                <HostRequestTalkToaster
                    closeToaster={() => {
                        setHostRequestTalkToasterShow(false);
                    }}
                />
            )}

            {!overlay && (
                <MessageToaster
                    show={messageToasterShow && !chatPanel && localStorage.getItem('chatMessagesEnabled') === 'true'}
                    onClose={handleCloseMessageToaster}
                    sender={newMessageSender}
                    message={newMessage}
                />
            )}


            <LeaveDialog
                isOpen={isLeaveDialogOpen}
                onConfirm={handleConfirmLeave}
                onCancel={handleCancelLeave}
            />

            {infoContentShow && (
                <InfoContent
                closeInfoContent={() => setInfoContentShow(false)}
                meetingInfo={meetingInfo}
                infoClass={infoClass}
                />
            )}

            {talkRequestAccepted && (
                <AcceptedTalkRequestToaster
                    message={requestToTalkAcceptedMessage}
                />
            )}

            {talkRequestDeclined && (
                <DeclineRequestNotification
                    message={requestToTalkDeclinedMessage}
                    closeToaster={() => {
                        setTalkRequestDeclined(false);
                    }}
                />
            )}

            {inviteDialogVisible && (
                <InviteDialog
                    inviterName={inviterName}
                    onAccept={handleAcceptInvite}
                    onDecline={handleDeclineInvite} />
            )}

            {inviteAcceptanceDialogVisible && (
                <AcceptRequestNotification />
            )}

            {participantLimitDialogOpen && (
                <ParticipantFullDialog
                    isOpen={participantLimitDialogOpen}
                    onClose={() => setParticipantLimitDialogOpen(false)}
                />
            )}

            {streamingDotSupportDialogOpen && (
                <StreamingDotSupportDialog
                    isOpen={streamingDotSupportDialogOpen}
                    onClose={() => setStreamingDotSupportDialogOpen(false)}
                />
            )}

        </div>
    )
}

export default Layout;
